const CodeGenerator = () =>
  import(
    /* webpackChunkName: "system-code-generator" */ '@/pages/system/code-generator/index.vue'
  )

export default {
  name: 'SystemCodeGenerator',
  path: '',
  meta: {
    label: 'codeGenerator',
    auth: true
  },
  component: {
    name: 'CodeGenerator',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingCodeGenerate',
      path: 'code-generator',
      meta: {
        label: 'create',
        auth: true
      },
      component: CodeGenerator
    }
  ]
}
